"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immutable = _interopRequireDefault(require("immutable"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIRouterLink = _interopRequireDefault(require("ui-addon-react-router/UIRouterLink"));

var _CategoryDropdown = _interopRequireDefault(require("../components/CategoryDropdown"));

var _CategoryNavigation = _interopRequireDefault(require("../components/CategoryNavigation"));

var _FeatureOptions = _interopRequireDefault(require("../constants/FeatureOptions"));

var _GoodFiltersAndPage = _interopRequireDefault(require("../constants/GoodFiltersAndPage"));

var _GoodSubTypes = _interopRequireDefault(require("../constants/GoodSubTypes"));

var _CustomModulePurposeOptions = _interopRequireDefault(require("../constants/CustomModulePurposeOptions"));

var _requestStatus = require("../constants/propTypes/requestStatus");

var _IndustryDropdown = _interopRequireDefault(require("../components/IndustryDropdown"));

var _TemplatePurposeDropdown = _interopRequireDefault(require("../components/TemplatePurposeDropdown"));

var _MultiselectCheckboxFilter = _interopRequireDefault(require("../components/MultiselectCheckboxFilter"));

var _MultiselectDropdownFilter = _interopRequireDefault(require("../components/MultiselectDropdownFilter"));

var _ProviderDropdown = _interopRequireDefault(require("../components/ProviderDropdown"));

var _PageLayoutFilter = _interopRequireDefault(require("../components/PageLayoutFilter"));

var GoodsActions = _interopRequireWildcard(require("../actions/GoodsActions"));

var _sidebarUtils = require("../utils/sidebarUtils");

var _langUtils = require("../utils/langUtils");

var _providers = require("../selectors/providers");

var DirectorySidebarContainer = _react.default.createClass({
  displayName: "DirectorySidebarContainer",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    allProviders: _propTypes.default.array.isRequired,
    categoryFilter: _propTypes.default.string.isRequired,
    childTypeFilters: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
    codingTypeFilters: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
    fetchProviders: _propTypes.default.func.isRequired,
    moduleCompatibilityFilter: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
    modulePurposeFilter: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
    onGoodFilterChange: _propTypes.default.func.isRequired,
    priceFilters: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
    industryFilter: _propTypes.default.string.isRequired,
    featureFilters: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
    pageLayoutFilter: _propTypes.default.string.isRequired,
    providerFilter: _propTypes.default.string,
    providersRequestStatus: _requestStatus.requestStatusPropType.isRequired,
    templatePurposeFilter: _propTypes.default.string.isRequired,
    trackAdjustedFilter: _propTypes.default.func.isRequired,
    trackLinkClick: _propTypes.default.func.isRequired,
    trackMultiselectSelection: _propTypes.default.func.isRequired
  },
  renderCustomModulePurposeFilter: function renderCustomModulePurposeFilter() {
    var _this$props = this.props,
        categoryFilter = _this$props.categoryFilter,
        modulePurposeFilter = _this$props.modulePurposeFilter,
        onGoodFilterChange = _this$props.onGoodFilterChange;

    if (categoryFilter !== _GoodSubTypes.default.CUSTOM_MODULE) {
      return null;
    }

    var sortedModulePurposeFilters = (0, _langUtils.getSortedSelectedFilters)(_GoodFiltersAndPage.default.MODULE_PURPOSE, modulePurposeFilter);
    return _react.default.createElement("div", {
      className: "integrate-module-function-filter m-y-4"
    }, _react.default.createElement(_MultiselectDropdownFilter.default, {
      defaultOption: _CustomModulePurposeOptions.default.NONE,
      filterType: _GoodFiltersAndPage.default.MODULE_PURPOSE,
      maxSelections: 3,
      onGoodFilterChange: onGoodFilterChange,
      selectedFilters: sortedModulePurposeFilters,
      trackMultiselectSelection: this.props.trackMultiselectSelection
    }));
  },
  renderCustomModuleCompatibilityFilter: function renderCustomModuleCompatibilityFilter() {
    var _this$props2 = this.props,
        categoryFilter = _this$props2.categoryFilter,
        moduleCompatibilityFilter = _this$props2.moduleCompatibilityFilter,
        onGoodFilterChange = _this$props2.onGoodFilterChange,
        trackMultiselectSelection = _this$props2.trackMultiselectSelection;

    if (categoryFilter !== _GoodSubTypes.default.CUSTOM_MODULE) {
      return null;
    }

    return _react.default.createElement("div", {
      className: "integrate-module-compatibility-filter m-y-4"
    }, _react.default.createElement(_MultiselectCheckboxFilter.default, {
      filterName: _GoodFiltersAndPage.default.MODULE_COMPATIBILITY,
      filtersCurrentlyAppliedInComponent: moduleCompatibilityFilter,
      onGoodFilterChange: onGoodFilterChange,
      showSelectAll: true,
      trackMultiselectSelection: trackMultiselectSelection
    }));
  },
  renderEmailCodingTypeFilter: function renderEmailCodingTypeFilter() {
    var _this$props3 = this.props,
        categoryFilter = _this$props3.categoryFilter,
        codingTypeFilters = _this$props3.codingTypeFilters,
        onGoodFilterChange = _this$props3.onGoodFilterChange,
        trackMultiselectSelection = _this$props3.trackMultiselectSelection;

    if (categoryFilter !== _GoodSubTypes.default.EMAIL_TEMPLATES) {
      return null;
    }

    return _react.default.createElement("div", {
      key: "emailCodingType",
      className: "m-y-4"
    }, _react.default.createElement(_MultiselectCheckboxFilter.default, {
      filterName: _GoodFiltersAndPage.default.CODING_TYPE,
      filtersCurrentlyAppliedInComponent: codingTypeFilters,
      onGoodFilterChange: onGoodFilterChange,
      trackMultiselectSelection: trackMultiselectSelection
    }));
  },
  renderPackChildTypeFilter: function renderPackChildTypeFilter() {
    var _this$props4 = this.props,
        categoryFilter = _this$props4.categoryFilter,
        childTypeFilters = _this$props4.childTypeFilters,
        onGoodFilterChange = _this$props4.onGoodFilterChange,
        trackMultiselectSelection = _this$props4.trackMultiselectSelection;

    if (categoryFilter !== _GoodSubTypes.default.PACKS) {
      return null;
    }

    var sortedChildTypeFilters = (0, _langUtils.getSortedSelectedFilters)(_GoodFiltersAndPage.default.CHILD_TYPES, childTypeFilters);
    return _react.default.createElement("div", {
      className: "integrate-pack-child-type-filter m-y-4"
    }, _react.default.createElement(_MultiselectCheckboxFilter.default, {
      filterName: _GoodFiltersAndPage.default.CHILD_TYPES,
      filtersCurrentlyAppliedInComponent: sortedChildTypeFilters,
      onGoodFilterChange: onGoodFilterChange,
      trackMultiselectSelection: trackMultiselectSelection
    }));
  },
  renderTemplateFilters: function renderTemplateFilters() {
    var _this$props5 = this.props,
        categoryFilter = _this$props5.categoryFilter,
        featureFilters = _this$props5.featureFilters,
        onGoodFilterChange = _this$props5.onGoodFilterChange,
        pageLayoutFilter = _this$props5.pageLayoutFilter,
        templatePurposeFilter = _this$props5.templatePurposeFilter;

    if (categoryFilter === _GoodSubTypes.default.ALL || categoryFilter === _GoodSubTypes.default.PACKS || categoryFilter === _GoodSubTypes.default.CUSTOM_MODULE) {
      return null;
    }

    var sortedFeatureFilters = (0, _langUtils.getSortedSelectedFilters)(_GoodFiltersAndPage.default.FEATURES, featureFilters);
    return [_react.default.createElement("div", {
      key: "intent",
      className: "m-y-4"
    }, _react.default.createElement(_TemplatePurposeDropdown.default, {
      onGoodFilterChange: onGoodFilterChange,
      templatePurposeFilter: templatePurposeFilter
    })), this.renderEmailCodingTypeFilter(), _react.default.createElement("div", {
      key: "pageLayout",
      className: "m-y-4"
    }, _react.default.createElement(_PageLayoutFilter.default, {
      onGoodFilterChange: onGoodFilterChange,
      pageLayoutFilter: pageLayoutFilter
    })), _react.default.createElement("div", {
      key: "features",
      className: "m-y-4"
    }, _react.default.createElement(_MultiselectDropdownFilter.default, {
      defaultOption: _FeatureOptions.default.NONE,
      filterType: _GoodFiltersAndPage.default.FEATURES,
      maxSelections: 3,
      onGoodFilterChange: onGoodFilterChange,
      selectedFilters: sortedFeatureFilters,
      trackMultiselectSelection: this.props.trackMultiselectSelection
    }))];
  },
  renderIndustryFilter: function renderIndustryFilter() {
    var _this$props6 = this.props,
        categoryFilter = _this$props6.categoryFilter,
        industryFilter = _this$props6.industryFilter,
        onGoodFilterChange = _this$props6.onGoodFilterChange;

    if (categoryFilter === _GoodSubTypes.default.ALL || categoryFilter === _GoodSubTypes.default.CUSTOM_MODULE) {
      return null;
    }

    return _react.default.createElement("div", {
      className: "m-y-4"
    }, _react.default.createElement(_IndustryDropdown.default, {
      onGoodFilterChange: onGoodFilterChange,
      industryFilter: industryFilter
    }));
  },
  renderPriceFilter: function renderPriceFilter() {
    var _this$props7 = this.props,
        priceFilters = _this$props7.priceFilters,
        onGoodFilterChange = _this$props7.onGoodFilterChange,
        trackMultiselectSelection = _this$props7.trackMultiselectSelection;
    return _react.default.createElement("div", {
      className: "integrate-price-filter m-y-4"
    }, _react.default.createElement(_MultiselectCheckboxFilter.default, {
      filterName: _GoodFiltersAndPage.default.PRICE,
      filtersCurrentlyAppliedInComponent: priceFilters,
      onGoodFilterChange: onGoodFilterChange,
      trackMultiselectSelection: trackMultiselectSelection
    }));
  },
  renderSidebarTitle: function renderSidebarTitle() {
    var menuParent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var _this$props8 = this.props,
        categoryFilter = _this$props8.categoryFilter,
        trackLinkClick = _this$props8.trackLinkClick;

    if (categoryFilter === _GoodSubTypes.default.ALL) {
      return _react.default.createElement("h5", null, _react.default.createElement(_FormattedMessage.default, {
        message: "sidebar.title"
      }));
    } else {
      return _react.default.createElement("h5", null, _react.default.createElement(_UIRouterLink.default, {
        className: "integrate-back-to-products",
        onClick: trackLinkClick.bind(null, "back-to-home-from-" + categoryFilter),
        to: '/products'
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "MarketplaceUI.directory.sidebar.multiselectCheckboxFilter.all"
      })), _react.default.createElement(_UIIcon.default, {
        name: "right",
        className: "m-x-1"
      }), (0, _langUtils.getCategoryOptionText)(menuParent));
    }
  },
  renderSubmenu: function renderSubmenu(menuOptions) {
    var _this$props9 = this.props,
        categoryFilter = _this$props9.categoryFilter,
        onGoodFilterChange = _this$props9.onGoodFilterChange,
        trackAdjustedFilter = _this$props9.trackAdjustedFilter,
        trackLinkClick = _this$props9.trackLinkClick;

    if (categoryFilter === _GoodSubTypes.default.ALL) {
      return _react.default.createElement(_CategoryDropdown.default, {
        categoryFilter: categoryFilter,
        onGoodFilterChange: onGoodFilterChange
      });
    }

    return _react.default.createElement(_CategoryNavigation.default, (0, _extends2.default)({
      categoryFilter: categoryFilter,
      trackAdjustedFilter: trackAdjustedFilter,
      trackLinkClick: trackLinkClick
    }, menuOptions));
  },
  renderProviders: function renderProviders() {
    var _this$props10 = this.props,
        allProviders = _this$props10.allProviders,
        fetchProviders = _this$props10.fetchProviders,
        onGoodFilterChange = _this$props10.onGoodFilterChange,
        providerFilter = _this$props10.providerFilter,
        providersRequestStatus = _this$props10.providersRequestStatus;
    return _react.default.createElement("div", {
      className: "m-y-4"
    }, _react.default.createElement(_ProviderDropdown.default, {
      allProviders: allProviders,
      fetchProviders: fetchProviders,
      onGoodFilterChange: onGoodFilterChange,
      providerFilter: providerFilter,
      providersRequestStatus: providersRequestStatus
    }));
  },
  render: function render() {
    var categoryFilter = this.props.categoryFilter;
    var menuOptions = (0, _sidebarUtils.getCategoryMenuOptions)(categoryFilter);
    return _react.default.createElement(_react.Fragment, null, this.renderSidebarTitle(menuOptions.parent), this.renderSubmenu(menuOptions), this.renderPriceFilter(), this.renderPackChildTypeFilter(), this.renderCustomModulePurposeFilter(), this.renderCustomModuleCompatibilityFilter(), this.renderTemplateFilters(), this.renderIndustryFilter(), this.renderProviders());
  }
});

function mapStateToProps(state) {
  var goodFilters = state.directoryData.get('goodFiltersAndPage');
  return {
    allProviders: (0, _providers.getProviderNames)(state),
    categoryFilter: goodFilters.get(_GoodFiltersAndPage.default.SUB_TYPE),
    childTypeFilters: goodFilters.get(_GoodFiltersAndPage.default.CHILD_TYPES),
    codingTypeFilters: goodFilters.get(_GoodFiltersAndPage.default.CODING_TYPE),
    priceFilters: goodFilters.get(_GoodFiltersAndPage.default.PRICE),
    industryFilter: goodFilters.get(_GoodFiltersAndPage.default.INDUSTRY),
    featureFilters: goodFilters.get(_GoodFiltersAndPage.default.FEATURES),
    pageLayoutFilter: goodFilters.get(_GoodFiltersAndPage.default.PAGE_LAYOUT),
    templatePurposeFilter: goodFilters.get(_GoodFiltersAndPage.default.TEMPLATE_PURPOSE),
    moduleCompatibilityFilter: goodFilters.get(_GoodFiltersAndPage.default.MODULE_COMPATIBILITY),
    modulePurposeFilter: goodFilters.get(_GoodFiltersAndPage.default.MODULE_PURPOSE),
    providerFilter: goodFilters.get(_GoodFiltersAndPage.default.PROVIDER),
    providersRequestStatus: (0, _providers.getProvidersRequestStatus)(state)
  };
}

var mapDispatchToProps = {
  fetchProviders: GoodsActions.getProviderNames,
  trackMultiselectSelection: GoodsActions.trackMultiselectSelection
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DirectorySidebarContainer);

exports.default = _default;
module.exports = exports.default;